import {
  GKButton,
  GKModal,
  GKSearchSelect,
  GKSelect,
  GKTextField,
  Grid2,
  MenuItem,
} from "components";
import useAddBranchModal from "hooks/useAddBranchModal";
import { Controller } from "react-hook-form";
import {
  SELECTED_CITY,
  SELECTED_COUNTRY,
  SELECTED_STATE,
} from "store/slices/appSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import { GKModalProps } from "utils/commonInterface";
import { validateNotWhitespaceOnly } from "utils/validationSchema";

interface Props {
  isEditModal: boolean;
  updateData: any;
}

const AddBranchModal = (props: Props & GKModalProps) => {
  const { open, setOpen, updateData, isEditModal } = props;

  const { branchData, isSubmitting, isFetching, form, onSubmit } =
    useAddBranchModal({
      setOpen,
      updateData,
      isEditModal,
    });

  const countryList = useAppSelector((state) => state?.app?.countryList);
  const stateList = useAppSelector((state) => state?.app?.stateList);
  const cityList = useAppSelector((state) => state?.app?.cityList);

  const dispatch = useAppDispatch();

  return (
    <GKModal
      open={open}
      setOpen={setOpen}
      modalTitle={isEditModal ? "Update Branch" : "Add New Branch"}
      width={"50%"}
      footer={
        <Grid2 container justifyContent={"flex-end"} gap={1}>
          <GKButton
            loading={isSubmitting}
            type="submit"
            variant="contained"
            size="medium"
            form="branch-form"
          >
            {isEditModal ? "Update" : "Submit"}
          </GKButton>
        </Grid2>
      }
    >
      <form onSubmit={form.handleSubmit(onSubmit)} id="branch-form">
        <Grid2 container spacing={1}>
          <Grid2 size={6}>
            <Controller
              name="name"
              control={form.control}
              rules={{
                required: {
                  value: true,
                  message: "Name is require",
                },
              }}
              render={({ field }) => (
                <GKTextField
                  {...field}
                  inputLabel="Branch Name"
                  placeholder="Branch Name"
                  requiredField
                  error={Boolean(form?.formState?.errors?.name)}
                  helperText={form?.formState?.errors?.name?.message as string}
                />
              )}
            />
          </Grid2>
          <Grid2 size={6}>
            <Controller
              name="parent"
              control={form.control}
              rules={{
                required: {
                  value: true,
                  message: "Reporting Branch is required",
                },
              }}
              render={({ field }) => (
                <GKSelect
                  {...field}
                  name="parent"
                  inputLabel="Reporting Branch"
                  placeholder="Reporting Branch"
                  requiredField
                  error={Boolean(form?.formState?.errors.parent)}
                  helperText={form?.formState?.errors.parent?.message as string}
                  disabled={isFetching}
                >
                  <MenuItem style={{ display: "none" }} value="">
                    Select reporting branch
                  </MenuItem>
                  {branchData?.map((data) => (
                    <MenuItem key={data.value} value={data.value}>
                      {data?.name}
                    </MenuItem>
                  ))}
                </GKSelect>
              )}
            />
          </Grid2>
          <Grid2 size={12}>
            <Controller
              name="address"
              control={form.control}
              rules={{
                required: {
                  value: true,
                  message: "Address is required",
                },
                validate: validateNotWhitespaceOnly,
              }}
              render={({ field }) => (
                <GKTextField
                  {...field}
                  inputLabel="Address"
                  placeholder="Address"
                  requiredField
                  name="address"
                  error={Boolean(form?.formState?.errors.address)}
                  helperText={
                    form?.formState?.errors.address?.message as string
                  }
                />
              )}
            />
          </Grid2>
          <Grid2 size={3}>
            <Controller
              name="country"
              control={form.control}
              render={({ field }) => (
                <GKSearchSelect
                  {...field}
                  inputLabel="Country"
                  options={countryList || []}
                  getOptionLabel={(e) => e.name || e}
                  onChange={(e, val) => {
                    field.onChange(val.name);
                    form.setValue("city", "");
                    form.setValue("state", "");
                    dispatch(SELECTED_COUNTRY(val.id));
                  }}
                />
              )}
            />
          </Grid2>
          <Grid2 size={3}>
            <Controller
              name="state"
              control={form.control}
              render={({ field }) => (
                <GKSearchSelect
                  {...field}
                  inputLabel="State"
                  options={stateList || []}
                  getOptionLabel={(e) => e.name || e}
                  onChange={(e, val) => {
                    field.onChange(val.name);
                    form.setValue("city", "");
                    dispatch(SELECTED_STATE(val.id));
                  }}
                />
              )}
            />
          </Grid2>
          <Grid2 size={3}>
            <Controller
              name="city"
              control={form.control}
              render={({ field }) => (
                <GKSearchSelect
                  {...field}
                  inputLabel="City"
                  options={cityList || []}
                  getOptionLabel={(e) => e.name || e}
                  onChange={(e, val) => {
                    field.onChange(val.name);
                    dispatch(SELECTED_CITY(val.id));
                  }}
                />
              )}
            />
          </Grid2>

          <Grid2 size={3}>
            <Controller
              name="pincode"
              control={form.control}
              render={({ field }) => (
                <GKTextField
                  {...field}
                  type="number"
                  inputLabel="Branch Pin code"
                  placeholder="Branch Pin code"
                />
              )}
            />
          </Grid2>
        </Grid2>
      </form>
    </GKModal>
  );
};

export default AddBranchModal;
